module.exports = __webpack_public_path__ + "img/quato3.facd68e3.png";